<script>
  import { cn } from '@lib/utils'
  
  let { main, aside, children, class: className } = $props()

  let twoColumnLayout = $derived(!children && !!aside)

  let layoutClass = $derived(twoColumnLayout ? "gap-2 xl:flex-row xl:justify-between xl:items-start xl:flex-nowrap" : "")
  
</script>

<div class={cn("flex flex-col px-4 py-6 sm:px-8", layoutClass, className)}>

  {#if children}
    {@render children()}
  {:else}

    {#if main}
      <main class="xl:w-[66%] flex flex-col gap-9">
        {@render main()}
      </main>
    {/if}

    {#if aside}
      <aside class="xl:w-[31%] flex flex-col gap-9">
        {@render aside()}
      </aside>
    {/if}
  
  {/if}
  
</div>